import {message} from '@sail/intl';

import type {MessageDescriptor} from '@sail/intl';

export const formatLast4WithDots = (last4: string) =>
  last4.length < 4 ? last4 : `••••${last4}`;

export const formatLast4WithMaxDots = (last4: string) =>
  `•••• •••• •••• ${last4}`;

// Reference code from manage/frontend/src/payments/helpers/formatBsb.tsx
export const formatBsb = (bsb: string): string => {
  const digits = bsb.replace(/[^0-9]/g, '');
  if (digits.length !== 6) {
    return bsb;
  }
  // Format the digits as 000-000
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}`;
};

// Referenced code from manage/frontend/src/payments/PaymentDetailPage/InstrumentDisplay/messages/klarnaMessages.tsx
const klarnaMessages = {
  payment_method_category_pay_with_financing: message({
    id: 'connectEmbedLib.paymentMethods.klarna.payment_method_category_pay_with_financing',

    description:
      'Human readable description of category pay_with_financing for the Klarna payment method.',

    defaultMessage: 'Pay with financing',
  }),

  payment_method_category_pay_later: message({
    id: 'connectEmbedLib.paymentMethods.klarna.payment_method_pay_later',

    description:
      'Human readable description of category pay_later for the Klarna payment method.',

    defaultMessage: 'Pay later',
  }),

  payment_method_category_pay_now: message({
    id: 'connectEmbedLib.paymentMethods.klarna.payment_method_category_pay_now',

    description:
      'Human readable description of category pay_now for the Klarna payment method.',

    defaultMessage: 'Pay now',
  }),

  payment_method_category_pay_in_installments: message({
    id: 'connectEmbedLib.paymentMethods.klarna.payment_method_category_pay_in_installments',

    description:
      'Human readable description of category pay_in_installments for the Klarna payment method.',

    defaultMessage: 'Pay in installments',
  }),

  payment_method_category_unknown: message({
    id: 'connectEmbedLib.paymentMethods.klarna.payment_method_category_unknown',
    description: 'Unknown Klarna payment method.',
    defaultMessage: 'Unknown',
  }),
};

export const formatKlarnaPaymentCategory = (
  category: string,
): MessageDescriptor => {
  switch (category) {
    case 'pay_with_financing':
      return klarnaMessages.payment_method_category_pay_with_financing;
    case 'pay_later':
      return klarnaMessages.payment_method_category_pay_later;
    case 'pay_now':
      return klarnaMessages.payment_method_category_pay_now;
    case 'pay_in_installments':
      return klarnaMessages.payment_method_category_pay_in_installments;
    default:
      return klarnaMessages.payment_method_category_unknown;
  }
};

// Referenced code from manage/frontend/src/payments/PaymentDetailPage/InstrumentDisplay/messages/konbiniMessages.tsx
export const konbiniStoreNames = {
  familymart: message({
    id: 'connectEmbedLib.paymentDetailPage.paymentSource.object.Konbini.storeNameEnum.familymart',

    description:
      'Human readable version of the Konbini chain name "FamilyMart"',

    defaultMessage: 'FamilyMart',
  }),

  lawson: message({
    id: 'connectEmbedLib.paymentDetailPage.paymentSource.object.Konbini.storeNameEnum.lawson',
    description: 'Human readable version of the Konbini chain name "Lawson"',
    defaultMessage: 'Lawson',
  }),

  ministop: message({
    id: 'connectEmbedLib.paymentDetailPage.paymentSource.object.Konbini.storeNameEnum.ministop',
    description: 'Human readable version of the Konbini chain name "Ministop"',
    defaultMessage: 'Ministop',
  }),

  seicomart: message({
    id: 'connectEmbedLib.paymentDetailPage.paymentSource.object.Konbini.storeNameEnum.seicomart',
    description: 'Human readable version of the Konbini chain name "Seicomart"',
    defaultMessage: 'Seicomart',
  }),
};
